const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjecteConfiguracio = async (id: string, json : any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/configuracio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(json)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
